module.exports = __webpack_public_path__ + "static/media/nk-logo.00bc6c05.png";